
import React, { RefObject } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import LegalSection from './LegalSection';

interface LegalDisclaimerProps {
  legalNoticesRef: RefObject<HTMLHeadingElement>;
  disclaimerRef: RefObject<HTMLHeadingElement>;
  copyrightRef: RefObject<HTMLHeadingElement>;
}

const LegalDisclaimer: React.FC<LegalDisclaimerProps> = ({
  legalNoticesRef,
  disclaimerRef,
  copyrightRef
}) => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  
  return (
    <>
      <LegalSection id="legal-notices" title={t.legalNotices} titleRef={legalNoticesRef}>
        <p className="mb-4 text-gray-300">
          Future Level ist bestrebt, die Inhalte dieser Webseite aktuell, vollständig und korrekt zu halten. Wir können jedoch keine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der bereitgestellten Informationen übernehmen.
        </p>
      </LegalSection>
      
      <LegalSection id="disclaimer" title={t.disclaimer} titleRef={disclaimerRef}>
        <p className="mb-4 text-gray-300">
          Future Level übernimmt keine Haftung für direkte oder indirekte Schäden, die durch die Nutzung dieser Webseite entstehen. Future Level behält sich das Recht vor, Änderungen oder Ergänzungen der bereitgestellten Informationen ohne vorherige Ankündigung vorzunehmen.
        </p>
      </LegalSection>
      
      <LegalSection id="copyright" title={t.copyright} titleRef={copyrightRef}>
        <p className="mb-4 text-gray-300">
          © {new Date().getFullYear()} Future Level. Der Inhalt dieser Webseite ist urheberrechtlich geschützt. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung von Future Level.
        </p>
      </LegalSection>
    </>
  );
};

export default LegalDisclaimer;
